import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

import { questionBaseSchema } from './question.schema';

export const questionTranslateOptionSchema = z.object({
  id: z.number(),
  content: z.string().min(1, 'Treść opcji nie może być pusta'),
});

export const questionTranslateSchema = questionBaseSchema.extend({
  type: z.literal(QuestionType.TRANSLATE),
  options: z.array(questionTranslateOptionSchema).min(1, 'Musisz dodać co najmniej 1 opcję').max(50, 'Maksymalnie 50 opcji'),
  points: z.number().positive('Punkty muszą być liczbą dodatnią'),
  explanation: z.string().optional(),
  answers: z.array(z.array(z.number())).min(1, 'Musisz dodać co najmniej 1 kombinację').max(5, 'Maksymalnie 5 kombinacji'),
});

export type QuestionTranslateOptionSchema = Infer<typeof questionTranslateOptionSchema>;

export type QuestionTranslateSchema = Infer<typeof questionTranslateSchema>;
